import { render, staticRenderFns } from "./PackMaterialRelationReport.vue?vue&type=template&id=590b0169&scoped=true&"
import script from "./PackMaterialRelationReport.vue?vue&type=script&lang=js&"
export * from "./PackMaterialRelationReport.vue?vue&type=script&lang=js&"
import style0 from "./PackMaterialRelationReport.vue?vue&type=style&index=0&id=590b0169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b0169",
  null
  
)

export default component.exports